import React from 'react'
import * as Sentry from '@sentry/browser'
import { formatToCEP } from 'brazilian-values-v2'

import ShowInMapButton from 'ui/components/ShowInMap'

import AnalysisButton from './AnalysisButton'

export const columnsCnaes = [
  {
    name: 'number',
    label: 'Número',
  },
  {
    name: 'description',
    label: 'Descrição da Atividade',
  },
]

export const columnsMembershipBoard = (analysisParams) => {
  return (
    [
      {
        name: 'name',
        label: 'Nome',
      },
      {
        name: 'qualification',
        label: 'Qualificação',
      },
      {
        name: 'doc_number',
        label: 'CPF/CNPJ',
      },
      {
        name: 'start_date',
        label: 'Data de Associação',
      },
      {
        name: 'doc_type',
        options: { display: false },
      },
      {
        name: 'create_analysis',
        label: 'Solicitar Análise',
        options: {
          customBodyRender: (_value, tableMeta, _updateValue) => {
            const docNumber = tableMeta.rowData[2]
            const docType = tableMeta.rowData[4]

            return (
              <AnalysisButton
                analysisParams={{
                  ...analysisParams,
                  docType: docType,
                  docNumber: docNumber,
                }}
              />
            )
          },
        },
      },
    ])
}

export const columnsLegalNature = [
  {
    name: 'number',
    label: 'Número',
  },
  {
    name: 'description',
    label: 'Descrição',
  },
]

export const columnsAddress = [
  {
    name: 'address',
    label: 'Logradouro',
  },
  {
    name: 'neighborhood',
    label: 'Bairro',
  },
  {
    name: 'city_state',
    label: 'Cidade/Estado',
  },
  {
    name: 'zipcode',
    label: 'CEP',
    options: {
      customBodyRender: (value) => {
        try {
          return value ? formatToCEP(value) : null
        } catch (err) {
          Sentry.captureException(err)
          return false
        }
      },
    },
  },
  {
    name: 'map',
    label: 'Ver no Mapa',
    options: {
      setCellHeaderProps: () => { return { style: { display:'flex', justifyContent:'center' } } },
      setCellProps: () => { return { style: { display:'flex', justifyContent:'center' } } },
      customBodyRender: (value) => (
        <span style={{ display:'flex', justifyContent:'center' }}>
          <ShowInMapButton address={value.address} zipcode={value.zipcode} cityState={value.cityState} />
        </span>
      ),
    },
  },
]
